import { useState } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import i18n from '../../../app/i18n';
import cms from '../../../app/api/cms';
import './ClientArchiveModal.scss';

const ClientArchiveModal = ({ clientId }) => {
  const [clientArchiveModalOpen, setClientArchiveModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onClickHandler = async () => {
    let formData = new FormData();

    formData.append('archive_action', 'archivate');

    await cms
      .ClientArchive(clientId, formData)
      .then(function (response) {
        if (response.data.message === 'action_success') {
          window.location.reload();
        }
      })
      .catch(function (error) {
        if (error.response.data.error !== undefined) {
          setErrorMessage(i18n.t(`formErrors.${error.response.data.error}`));
        }
      });
  };

  const onCancelHandler = () => {
    setClientArchiveModalOpen(false);
  };

  function clientArchiveModal() {
    return (
      <Modal className='delete-user-model' centered={true} isOpen={clientArchiveModalOpen} toggle={onCancelHandler}>
        <ModalHeader charcode='Y' toggle={() => setClientArchiveModalOpen(false)}></ModalHeader>
        <ModalBody>
          <p>{errorMessage}</p>
          <h6>{i18n.t('archiveClientPopup.sureArchiveClient')}</h6>
        </ModalBody>
        <ModalFooter className='d-flex justify-content-between'>
          <button onClick={onClickHandler} className='confirm-user-deletion'>
            {i18n.t('archiveClientPopup.archiveClient')}
          </button>
          <button className='cancel-user-deletion' onClick={onCancelHandler}>
            {i18n.t('archiveClientPopup.abortDeletion')}
          </button>
        </ModalFooter>
      </Modal>
    );
  }

  return (
    <>
      {clientArchiveModal()}
      <button onClick={() => setClientArchiveModalOpen(true)} className='client-archive-btn'>
        Archyvuoti
      </button>
    </>
  );
};

export default ClientArchiveModal;
